import IconTimbitArrowRight from 'components/icons/timbit-arrow-right';
import IconTimbitLove from 'components/icons/timbit-love';
import IconTimbitShock from 'components/icons/timbit-shock';
import IconTimbitTapping from 'components/icons/timbit-tapping';
import IconTimbitWaiter from 'components/icons/timbit-waiter';

export const DEFAULT_ICON = IconTimbitShock;
export const NEARBY_ERROR_ICON = IconTimbitShock;
export const NEARBY_NO_STORES_ICON = IconTimbitArrowRight;
export const NEARBY_NO_LOCATION_ICON = IconTimbitShock;
export const FAVORITES_ERROR_ICON = IconTimbitShock;
export const FAVORITES_NO_AUTH_ICON = IconTimbitWaiter;
export const FAVORITES_NO_STORES_ICON = IconTimbitLove;
export const RECENT_ERROR_ICON = IconTimbitShock;
export const RECENT_NO_AUTH_ICON = IconTimbitWaiter;
export const RECENT_NO_STORES_ICON = IconTimbitTapping;
